/**
 * Internal dependencies
 */
import WMUToggleGroup from './toggle-group';
import WMUUtils from '@wakemeup/utils';

/**
 * @todo Utiliser cette classe pour remplacer le code gérant le toggle du menu principal
 */
class WMUToggleClass extends EventTarget {

	/**
	 * 
	 */
	constructor( toggleElement, args = {} )
	{
		super();

		this.args = {
			attributeClassOn: 'data-toggle-class-on',
			attributeClassOff: 'data-toggle-class-off',
			attributeFx: 'data-toggle-fx',
			attributeFxTargetSelector: 'data-toggle-fx-target-selector',
			attributeInitStatus: 'data-toggle-init-status',
			attributeTargetSelector: 'data-toggle-target-selector',
			classOn: 'toggle-on',
			classOff: 'toggle-off',
			fx: '',
			fxTargetSelector: '',
			ignoreHtmlAttributes: false,
			initStatus: 'off',
			targetSelector: null,
			autoInit: true,
			...args
		};

		this.currentStatus = null;
		this.fxTargetElementList = null;
		this.toggleElement = toggleElement;
		this.targetElementList = null;
		this.isInit = false;

		if ( this.toggleElement )
		{
			this.toggleElement.wmuToggle = this;
		}

		if ( true === this.args.autoInit )
		{
			this.init();
		}
	}

	/**
	 * 
	 */
	init()
	{
		if ( false === this.args.ignoreHtmlAttributes )
		{
			this.readAttributeArgs();
		}

		const initStatus = this.getArg( 'initStatus' );

		if ( initStatus )
		{
			this.setStatus( initStatus );
		}

		this.initBehaviors();
		this.isInit = true;
		this.toggleElement.classList.add( 'toggle-init' );
		this.getTargets().forEach( target => target.classList.add( 'toggle-target-init' ) );
	}

	/**
	 * 
	 */
	initBehaviors()
	{
		this.onToggleStatus = this.onToggleStatus.bind( this );

		this.toggleElement.addEventListener( 'click', this.onToggleStatus );
	}

	/**
	 * 
	 */
	clear()
	{
		if ( this.toggleElement )
		{
			this.toggleElement.classList.remove( 'toggle-init' );
			this.toggleElement.removeEventListener( 'click', this.onToggleStatus );
			this.toggleElement = null;
		}

		if ( this.fxTargetElementList )
		{
			const fx = this.getArg( 'fx' );

			this.fxTargetElementList.forEach( ( element ) =>
			{
				WMUUtils.clearFxInstance( element, fx );
			} );
		}

		// Remove status class on targets
		const targets = this.getTargets();
		const classOn = this.getArg( 'classOn' );
		const classOff = this.getArg( 'classOff' );
		const classesOn = ( classOn ) ? classOn.split( ' ' ) : [];
		const classesOff = ( classOff ) ? classOff.split( ' ' ) : [];
		const classes = [ 'toggle-target-init', ...classesOff, ...classesOn ];

		targets.forEach( target => target.classList.remove( ...classes ) );
	}

	/**
	 * 
	 */
	onToggleStatus( event )
	{
		// event.preventDefault();
		this.toggleStatus();
		return false;
	}

	/**
	 * 
	 */
	readAttributeArgs()
	{
		this.attributeArgs = {
			classOn: this.toggleElement.getAttribute( this.args.attributeClassOn ) || undefined,
			classOff: this.toggleElement.getAttribute( this.args.attributeClassOff ) || undefined,
			fx: this.toggleElement.getAttribute( this.args.attributeFx ) || undefined,
			fxTargetSelector: this.toggleElement.getAttribute( this.args.attributeFxTargetSelector ) || undefined,
			initStatus: this.toggleElement.getAttribute( this.args.attributeInitStatus ) || undefined,
			targetSelector: this.toggleElement.getAttribute( this.args.attributeTargetSelector ) || undefined
		};
	}

	/**
	 * 
	 */
	getArg( key )
	{
		if ( true === this.args.ignoreHtmlAttributes || ! this.attributeArgs ||  undefined === this.attributeArgs[ key ] )
		{
			return this.args[ key ];
		}

		return ( this.attributeArgs ) ? this.attributeArgs[ key ] : undefined;
	}

	/**
	 *  
	 */
	getTargets()
	{
		if ( null === this.targetElementList )
		{
			const targetSelector = this.getArg( 'targetSelector' );

			if ( targetSelector )
			{
				this.targetElementList = WMUUtils.querySelectorAll( targetSelector, this.toggleElement );
			}
			else
			{
				/**
				 * Est-ce qu'on ne place pas this.toggleElement en target dans ce cas ?
				 */
				this.targetElementList = [];
			}
		}

		return this.targetElementList;
	}

	/**
	 * 
	 */
	setStatus( status )
	{
		const targets = this.getTargets();
		const classOn = this.getArg( 'classOn' );
		const classOff = this.getArg( 'classOff' );
		const classesOn = ( classOn ) ? classOn.split( ' ' ) : [];
		const classesOff = ( classOff ) ? classOff.split( ' ' ) : [];
		const previousStatus = this.currentStatus;
		
		this.currentStatus = status;

		if ( 'on' === status )
		{
			targets.forEach( ( target ) =>
			{
				if ( classOff )
				{
					target.classList.remove( ...classesOff );
				}

				if ( classOn )
				{
					target.classList.add( ...classesOn );
				}
			} );

			this.dispatchEvent( new CustomEvent( 'toggleOn', { detail: {
				toggle: this
			} } ) );
		}
		else if ( 'off' === status )
		{
			targets.forEach( ( target ) =>
			{
				if ( classOff )
				{
					target.classList.add( ...classesOff );
				}

				if ( classOn )
				{
					target.classList.remove( ...classesOn );
				}
			} );

			this.dispatchEvent( new CustomEvent( 'toggleOff', { detail: {
				toggle: this
			} } ) );
		}

		this.dispatchEvent( new CustomEvent( 'setStatus', { detail: {
			newStatus: status,
			previousStatus: previousStatus,
			toggle: this
		} } ) );

		this.applyFx( status );
	}

	/**
	 * 
	 */
	toggleStatus()
	{
		if ( null === this.currentStatus || 'off' === this.currentStatus )
		{
			this.setStatus( 'on' );
		}
		else
		{
			this.setStatus( 'off' );
		}
	}

	/**
	 * 
	 */
	applyFx( status = null )
	{
		const fx = this.getArg( 'fx' );

		if ( fx )
		{
			if ( null === status )
			{
				status = this.currentStatus;
			}

			const targets = this.getFxTargets();

			targets.forEach( ( element ) =>
			{
				const fxArgs = {};

				switch ( fx )
				{
					case 'expand-collapse':
						fxArgs.initState = ( this.getArg( 'initStatus' ) === 'on' ) ? 'expand' : 'collapse';
					break;
				}

				const fxInstance = WMUUtils.fxInstance( element, fx, fxArgs );

				if ( fxInstance )
				{
					switch( fx )
					{
						case 'expand-collapse':
							switch ( status )
							{
								case 'on':
									fxInstance.start( 'expand' );
								break;
	
								case 'off':
									fxInstance.start( 'collapse' );
								break;
							}
						break;
					}
				}
			} );
		}
	}

	/**
	 *  
	 */
	getFxTargets()
	{
		if ( null === this.fxTargetElementList )
		{
			const targetSelector = this.getArg( 'fxTargetSelector' );

			if ( targetSelector )
			{
				this.fxTargetElementList = WMUUtils.querySelectorAll( targetSelector, this.toggleElement );
			}
			else
			{
				this.fxTargetElementList = [];
			}
		}

		return this.fxTargetElementList;
	}

	/**
	 * 
	 * @param {*} args 
	 * @returns 
	 */
	static group( args )
	{
		return new WMUToggleGroup( args );
	}

}

export default WMUToggleClass;
